"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _ContentView = _interopRequireDefault(require("../../ContentView"));

require("../styles/_comment-body.scss");

function CommentBody(a) {
  var b = a.content,
      c = a.small;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("comment-body", {
      "comment-body--small": c
    })
  }, _react["default"].createElement(_ContentView["default"], {
    content: b,
    truncate: !0
  }));
}

var _default = CommentBody;
exports["default"] = _default;